export default "__VITE_ASSET__DlUeFIAI__"